export * from './singleton-injector';
